/*
 * Module handling the conversation diagram on the topic page
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicDiagramArea/topicDiagram/topicDiagramView",
], function (Marionette, Messenger, TopicDiagramView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicDiagram";
      this.selectedModel = null; //the selected node, we keep track of it to "un-highlight" it
      this.readOnly = options.readOnly; //set to true if we don't want to be able to add or remove nodes from this diagram.  We can still select nodes, though.
      this._setUpVents();
    },
    show: function (conversation) {
      console.log("READ ONLY: " + this.readOnly);
      this.view = new TopicDiagramView.topicDiagramView({
        model: conversation,
        readOnly: this.readOnly,
      });
      conversation.on("sync", () => this._onConversationSync(conversation));
      this.view.on(
        "show",
        function () {
          //initialize the diagram once the view is being shown
          //set start node as selected, either now or when the conversation is synced (only if not read-only)
          if (!this.readOnly) {
            conversation.onSynced(() => this._initializeDiagram(conversation));
          }
        },
        this,
      );
      this.showRegion(this.view);
    },
    _addNode: function (view) {
      if (view.model.decisionCol.length === 0) {
        //adding branches to a node without any branches-->start off with two branches (decision choices)
        //create the first branch here and let the code below create the 2nd one
        view.decisionCounter = 1;
        view.model.addDecision("Decision " + view.decisionCounter);
      }
      if (!view.decisionCounter) {
        //keep track of the count digit we use for newly created decisions
        view.decisionCounter = view.model.decisionCol.length;
      }
      const decisionCount = ++view.decisionCounter;
      view.model.addDecision("Decision " + decisionCount); //add decision to the conversation model
      //trigger event that the conversation structure was changed
      Messenger.vent.trigger("conversation:changed");
      //highlight current node (gets wiped out with the rerender)
      this.selectedModel.trigger("highlight");
    },
    _initializeDiagram: function (conversation) {
      //this._selectNode(conversation); //set start node as the selected now
      this.selectedModel = conversation; //set "start" model as selected
      this.selectedModel.trigger("highlight"); //highlight the start node
    },
    _onConversationSync: function (conversation) {
      const oldSelectedModel = this.selectedModel;
      this.view._manage();
      if (!oldSelectedModel) {
        return;
      }

      let newSelectedModel = null;

      function checkModelMatch(c) {
        if (oldSelectedModel.get("responseId") == c.get("responseId")) {
          newSelectedModel = c;
        } else if (c.decisionCol) {
          c.decisionCol.each(checkModelMatch);
        }
      }

      checkModelMatch(conversation);
      if (newSelectedModel) {
        this._initializeDiagram(newSelectedModel);
        this._selectNode(newSelectedModel);
      }
    },
    _selectNode: function (conversationNode) {
      //trigger event that node was selected
      Messenger.vent.trigger("selected:node", conversationNode);
    },
    _setUpVents: function () {
      if (!this.readOnly) {
        //note that clicking on a read only diagram will still cause the selection to be
        //changed if there is another editable diagram in existance.  This is because
        //the editable diagram will handle the clicked:diagram event and change the selected node.
        Messenger.vent.on(
          "clicked:diagram",
          function (view) {
            //if a textbox is open, don't do anything unless it can close, because the textbox could get re-rendered and break
            if (Messenger.reqres.request("save:textbox")) {
              this._selectNode(view.model); //change which node is selected
              if (this.selectedModel !== null) {
                this.selectedModel.trigger("unhighlight"); //trigger event to "un-highlight"
              }
              this.selectedModel = view.model;
              this.selectedModel.trigger("highlight"); //highlight the node
            }
          },
          this,
        );

        //create a branching conversation from a basic FAQ
        Messenger.vent.on(
          "create:conversation",
          function () {
            this._addNode(this.view); //add starting branch to root node
            Messenger.vent.trigger("conversation:created"); //trigger event that the conversation has been created
          },
          this,
        );

        Messenger.vent.on(
          "add:node",
          function (view) {
            this._addNode(view);
          },
          this,
        );

        Messenger.vent.on(
          "delete:node",
          function (view) {
            if (Messenger.reqres.request("save:textbox")) {
              //confirm delete
              Messenger.yesNoDialog(
                "topic.diagram.dialog.delete",
                {
                  yes: () => {
                    const topicId = Messenger.reqres.request("current:topic:id");
                    Messenger.vent.trigger("track:interaction", {
                      action: "Delete Topic Conversation Node",
                      id: [topicId, view.model.id],
                      idType: ["Topic", "Conversation Node"],
                      object: "Topic Conversation Node",
                    });
                    //if the node is the last child, then select its parent
                    let switchedToView;
                    if (view.model.collection.length === 1) {
                      //we know that the model is part of a collection, so this is a safe operation
                      switchedToView = view.parent;
                    } else {
                      //get position of model in collection
                      const index = view.model.collection.indexOf(view.model);
                      //switch to the next decision node in the collection
                      let nextIndex;
                      if (index < view.model.collection.length - 1) {
                        nextIndex = index + 1;
                      } else {
                        //if there isn't a decision node after it, take the one before
                        nextIndex = index - 1;
                      }
                      const switchedToModel = view.model.collection.at(nextIndex);
                      console.log(switchedToModel.get("description"));
                      //get the view using the newly selected model
                      switchedToView = view.parent.children.findByModel(switchedToModel);
                    }
                    //Delete the model from the diagram's view
                    view.model.deleteModel();

                    //Let the topic know that a node was deleted, so that it can be set to dirty and will save
                    Messenger.vent.trigger("conversation:delete:node", view.model);

                    this._selectNode(switchedToView.model);
                    this.selectedModel = switchedToView.model;
                    this.selectedModel.trigger("highlight");
                    Messenger.vent.trigger("conversation:changed");
                  },
                },
                this,
              );
            }
          },
          this,
        );
      }
    },
  });
});
